function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.397 32A5.198 5.198 0 110 32a5.198 5.198 0 0110.397 0m26.801 0a5.198 5.198 0 11-10.397 0 5.198 5.198 0 0110.397 0M64 32a5.198 5.198 0 11-10.397 0 5.198 5.198 0 0110.396 0",
  fill: "currentColor",
  fillRule: "nonzero"
});

function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIyIj4KICA8cGF0aCBkPSJNMTAuMzk3IDMyQTUuMTk4IDUuMTk4IDAgMTEwIDMyYTUuMTk4IDUuMTk4IDAgMDExMC4zOTcgME0zNy4xOTggMzJhNS4xOTggNS4xOTggMCAxMS0xMC4zOTcgMCA1LjE5OCA1LjE5OCAwIDAxMTAuMzk3IDBNNjQgMzJhNS4xOTggNS4xOTggMCAxMS0xMC4zOTcgMCA1LjE5OCA1LjE5OCAwIDAxMTAuMzk2IDAiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJub256ZXJvIi8+Cjwvc3ZnPg==";
export { SvgMenu as ReactComponent };